exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.message-iframe-wrap[data-v-2b470f12]{width:100%;height:calc(100vh - 53px - 40px)\n}\n", "", {"version":3,"sources":["/data/jenkins/workspace/shop/src/pages/notice/messageList.vue"],"names":[],"mappings":";AA+BA,sCACE,WACA,gCAAiC;CAClC","file":"messageList.vue","sourcesContent":["\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n.message-iframe-wrap {\n  width: 100%;\n  height: calc(100vh - 53px - 40px);\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2b470f12","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/notice/messageList.vue
// module id = BScM
// module chunks = 2